<!-- <div class="sales-content">
  <div class="checkbox" [class.checked]="selected" (click)="toggleSelection()" >
    <svg *ngIf="selected" width="10" height="10" viewBox="0 0 12 12" fill="none">
    <path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <div class="main-content">Hide Location Without Sales</div>
</div> -->


<div class="range-header">
  <div class="range-title">Store Size Range</div>
  <div class="range-display" *ngIf="externalRangeMin !== null && externalRangeMax !== null">{{ formatNumber(minValue) }} - {{ formatNumber(maxValue) }} sq ft</div>
</div>

<!-- Loading -->
<div *ngIf="externalRangeMin === null || externalRangeMax === null" class="slider-loader">
  <div class="circular-loader"></div>
</div>

<!-- Range Slider (only shown after external bounds arrive) -->
<ng-container *ngIf="externalRangeMin !== null && externalRangeMax !== null">
  <div class="range-slider-container">
    <div class="slider-wrapper">
      <div class="slider-track"></div>
      <div class="slider-progress" [style.width.%]="getProgressWidth()" [style.left.%]="getProgressLeft()"></div>

      <!-- Min Handle -->
      <div class="slider-handle min-handle"
           [style.left.%]="getMinHandlePosition()"
           (mousedown)="startDrag('min', $event)">
      </div>

      <!-- Max Handle -->
      <div class="slider-handle max-handle"
           [style.left.%]="getMaxHandlePosition()"
           (mousedown)="startDrag('max', $event)">
      </div>

      <!-- Range Labels -->
      <div class="range-labels">
        <div class="min-label">{{ formatNumber(rangeMin) }}</div>
        <div class="max-label">{{ formatNumber(rangeMax) }}</div>
      </div>
    </div>
  </div>

  <!-- Min/Max Inputs -->
  <div class="input-section">
    <div class="input-group">
      <div class="input-label">Min (SQFT)</div>
      <div class="input-container">
        <div class="input-wrapper" [class.error]="hasMinError">
          <input type="text"
                 class="value-input"
                 placeholder="5,000"
                 [value]="formatInputValue(minInputValue)"
                 (input)="onMinInputChange($event)"
                 (blur)="validateInputs()">
        </div>
        <div class="error-message" *ngIf="hasMinError">
          Value must be between {{ formatNumber(rangeMin) }} and {{ formatNumber(rangeMax) }}
        </div>
      </div>
    </div>

    <div class="input-group">
      <div class="input-label">Max (SQFT)</div>
      <div class="input-container">
        <div class="input-wrapper" [class.success]="!hasMaxError">
          <input type="text"
                 class="value-input"
                 placeholder="25,000"
                 [value]="formatInputValue(maxInputValue)"
                 (input)="onMaxInputChange($event)"
                 (blur)="validateInputs()">
        </div>
      </div>
    </div>
  </div>
</ng-container>
